export type HelperNotification = {
  title: string
  body: string
  tag?: string
}

type Listener = (notification: HelperNotification) => void

const listeners = new Set<Listener>()

const isBrowser = (): boolean => typeof window !== 'undefined' && typeof Notification !== 'undefined'

export const requestHelperNotificationPermission = async (): Promise<NotificationPermission> => {
  if (!isBrowser()) return 'denied'
  if (Notification.permission === 'granted') return 'granted'
  if (Notification.permission === 'denied') return 'denied'
  try {
    return await Notification.requestPermission()
  } catch {
    return 'denied'
  }
}

export const subscribeHelperNotifications = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const emitFallback = (notification: HelperNotification): void => {
  for (const listener of listeners) listener(notification)
}

export const notifyHelper = (notification: HelperNotification): void => {
  if (isBrowser() && Notification.permission === 'granted') {
    try {
      new Notification(notification.title, { body: notification.body, tag: notification.tag })
      return
    } catch {
      // fall through to listener fallback
    }
  }
  emitFallback(notification)
}
